import { Component, OnInit } from '@angular/core';
import {HeaderService} from "../../../../../services/header/header.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-add-bon-transfert',
  templateUrl: './add-bon-transfert.component.html',
  styleUrls: ['./add-bon-transfert.component.scss']
})
export class AddBonTransfertComponent implements OnInit {

  constructor(private headerService: HeaderService,  private router: Router) { }

  ngOnInit(): void {

  }


}
